import React from 'react'
import Input from '../Input'
import { InputProps } from '../Input/Input'
import Textarea from '../Textarea'
import useDeprecatedComponent from '../../lib/hooks/useDeprecatedComponent'

type Props = {
  /** If `true`, a textarea will be used instead of a input. */
  multiline?: boolean
}

export type TextInputProps = Props & InputProps

const TextInput = (props: TextInputProps) => {
  useDeprecatedComponent('TextInput', 'Please use Input or Textarea.')

  const { type = 'text', multiline, required, ...rest } = props
  const supportedTypes: Array<string> = ['email', 'number', 'password', 'search', 'tel', 'text', 'url']

  if (!multiline && !supportedTypes.includes(type)) {
    const message = `[AIRBUS-DS] TextInput of type '${type}' is unknow or not supported.`
    console.warn(message)
    return null
  }

  const commonProps = {
    required,
    'aria-required': required,
    ...(rest as any),
  }

  if (multiline) {
    return <Textarea rows={4} {...commonProps} />
  }

  return <Input type={type} {...commonProps} />
}

export default TextInput
